import script from "./Camera.vue?vue&type=script&setup=true&lang=ts"
export * from "./Camera.vue?vue&type=script&setup=true&lang=ts"

import "./Camera.vue?vue&type=style&index=0&id=47535364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47535364"]])

export default __exports__